import ScrollableContainer from '../util/ScrollableContainer'
import TypesOfWorkList from './TypesOfWorkList'
import {connect} from "../redux/utils";
import TypeOfWorkNode from "./TypeOfWorkNode";
import TemplateView from "../TemplateView";
import {getSortedTypeOfWorkList} from "./selectors";
import SearchField from '../taskManagement/SearchField';

class TypeOfWorkSelector extends TemplateView {
    constructor({
        onlyActive = true,
        onTypeSelected = () => {},
    }) {
        super()

        this.params = {
            onlyActive,
            onTypeSelected,
        }

        this.state = {
            typesOfWork: [],
            selectedTypeId: -1,
            searchText: ''
        }

        this.onAnyStatePropertyChanged(['typesOfWork','selectedTypeId','searchText'],() => this._renderList())
    }

    templateHtml() {
        return '<div class="components_typeOfWorkSelector">' +
               '    <div class="components_typeOfWorkSearchField" />' +
               '    <div class="components_typeOfWorkSelectorList" />' +
               '</div>'
    }

    afterRender() {
        const $searchFieldContainer = this.find(".components_typeOfWorkSearchField")
        this.searchField = new SearchField({
            onFieldChange: this.filterTypeOfWork
        }).init($searchFieldContainer);
        this._renderList()
    }

    filterTypeOfWork = (searchText) => {
        this.setState({ searchText })
    }

    onTypeSelected = (id) => {
        this.params.onTypeSelected(id)
        this.setState({ searchText: '' })
        this.searchField.clear()
    }

    update() {
        super.update()
        if (this.scrollableContainer)
            this.scrollableContainer.forceUpdate()
    }

    _renderList() {
        const list = this.$el.find(".components_typeOfWorkSelectorList")
        list.empty()

        this.scrollableContainer = new ScrollableContainer(
            null,
            new TypesOfWorkList({
                nodeRenderer: ($el, typeOfWork, searchText) => {
                    new TypeOfWorkNode({
                            typeOfWork,
                            selected: this.state.selectedTypeId === typeOfWork.id,
                            onClick: this.onTypeSelected,
                            searchText
                        }
                    ).init($el)
                },
            })
        )
        this.scrollableContainer.init(list).setState({
            typesOfWork: this._getTypesOfWork(),
            searchText: this.state.searchText
        })
    }

    _getTypesOfWork() {
        const filteredTypesOfWorks = this.state.typesOfWork.filter(t => t.name.startsWith(this.state.searchText))
        if (this.params.onlyActive) {
            return filteredTypesOfWorks.reduce((acc, t) => {
                if (t.active) acc.push(t)
                // if assigned ToW is archived, place it first in list
                if (!t.active && t.id === this.state.selectedTypeId) {
                    t.position = -1
                    acc.push(t)
                }
                return acc
            }, [])
        }

        return filteredTypesOfWorks
    }
}

export default connect(
    state => ({
        typesOfWork: getSortedTypeOfWorkList(state)
    }),
)(TypeOfWorkSelector)


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypeOfWorkSelector.js